import React from 'react';
import { Switch, Route } from 'react-router-dom';
import Box from 'ui-box';
import AntdAlertErrorBoundary from '../../components/common/AntdAlertErrorBoundary';
import MobileHeader from '../../components/mobile/Header';
import SpeakDoctorScreen from '../../pages/mobile/speak-doctor/SpeakDoctorScreen';
import PregnantScreen from '../../pages/mobile/speak-doctor/pregnant/PregnantScreen';
import NutritionScreen from '../../pages/mobile/speak-doctor/NutritionScreen';
import MentalHealthQuestion from '../../pages/mobile/speak-doctor/MentalHealthQuestionScreen';
import CovidScreen from '../../pages/mobile/speak-doctor/CovidScreen';
import SubmitResponseScreen from '../../pages/mobile/speak-doctor/SubmitResponseScreen';

import CurrentPregnantScreen from '../../pages/mobile/speak-doctor/pregnant/CurrentPregnantScreen';
import NewParentScreen from '../../pages/mobile/speak-doctor/pregnant/NewParentScreen';
import PlanningGetPregnantScreen from '../../pages/mobile/speak-doctor/pregnant/PlanningGetPregnantScreen';

function MobileSpeakDoctorLayout() {

  return (
    <>
      <Box position="relative" height="100%">
        <AntdAlertErrorBoundary>
          <MobileHeader />
        </AntdAlertErrorBoundary>
        <AntdAlertErrorBoundary>
          <Box paddingTop={24} paddingBottom={12} paddingX={20} marginBottom={40}>
            <Switch>
              <Route path="/speak-doctor/submit-response">
                <SubmitResponseScreen />
              </Route>
              <Route path="/speak-doctor/covid">
                <CovidScreen />
              </Route>
              <Route path="/speak-doctor/mental-health-questions">
                <MentalHealthQuestion />
              </Route>
              <Route path="/speak-doctor/nutrition">
                <NutritionScreen />
              </Route>
              <Route path="/speak-doctor/pregnancy/planning-get-pregnant/">
                <PlanningGetPregnantScreen />
              </Route>
              <Route path="/speak-doctor/pregnancy/new-parent/">
                <NewParentScreen />
              </Route>
              <Route path="/speak-doctor/pregnancy/current-pregnant/">
                <CurrentPregnantScreen />
              </Route>
              <Route path="/speak-doctor/pregnancy">
                <PregnantScreen />
              </Route>
              <Route path="/speak-doctor">
                <SpeakDoctorScreen />
              </Route>
            </Switch>
          </Box>
        </AntdAlertErrorBoundary>
      </Box>
    </>
  );
}

export default MobileSpeakDoctorLayout;
